module.exports = __webpack_public_path__ + "img/catalogue.ddacbbab.jpg";